// export const trackPageView = () => {
//   if (typeof window.fbq === "function") {
//     window.fbq("track", "PageView");
//   }
// };

// export const trackEvent = (event, params = {}) => {
//   if (typeof window.fbq === "function") {
//     window.fbq("track", event, params);
//   }
// };


export const trackPageView = () => {
  if (typeof window.fbq === "function") {
    console.log("Facebook PageView tracked:", window.location.pathname);
    window.fbq("track", "PageView");
  } else {
    console.warn(" fbq not loaded");
  }
};

export const trackEvent = (event, params = {}) => {
  if (typeof window.fbq === "function") {
    console.log(" Meta Event:", event, params);
    window.fbq("track", event, params);
  }
};

